<template>
  <AnalyticsWidget
    title="Recut Summary"
    :subTitle="`Summary data based on this month. All price values ex-${taxName}`"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight"
    >
    <div class="p-2">
      <LoadingPanel :loading="loading" />
      <div v-if="!loading">
        <AnalyticsDashboardValueRow>
          <div class="col">
            <AnalyticsDashboardValue
              title="Total Recut Panels"
              :value="summaryData.recutPanelTotalCount">
              {{formatInteger(summaryData.recutPanelTotalCount, false, true)}}
              <template v-slot:info>&nbsp;</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Total Recut Panel Value"
              :value="summaryData.recutPanelTotalValue">
              {{formatCurrency(summaryData.recutPanelTotalValue)}}
              <template v-slot:info>&nbsp;</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Total Processed Panels"
              :value="summaryData.allPanelTotalCount">
              {{formatInteger(summaryData.allPanelTotalCount, false, true)}}
              <template v-slot:info>&nbsp;</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Recut Panel Percent Of Processed Panels"
              :value="summaryData.recutPanelPercent">
              {{formatPercent(summaryData.recutPanelPercent)}}
              <template v-slot:info>&nbsp;</template>
            </AnalyticsDashboardValue>
          </div>
        </AnalyticsDashboardValueRow>
      </div>
    </div>
  </AnalyticsWidget>
</template>


<script>
import moment from 'moment'
import { mapState } from 'vuex'

import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'
import AnalyticsDashboardValueRow from '@/modules/intelligence/components/analyticsDashboardValueRow'

export default {
  name: 'RecutSummaryWidget',
  components: {
    AnalyticsWidget,
    AnalyticsDashboardValue,
    AnalyticsDashboardValueRow
  },
  props: {
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
    ...mapState({
      taxName: state => state.account.salesTaxRate.name
    }),
  },
  data() {
    return {
      loading: true,
      summaryData: {},
    }
  },
  mounted() {
    this.loading = true
    this.requestData()
  },
  methods: {
    requestData() {
      var filterData = {
        startDate: moment().local().startOf('month').toDate().toISOString(),
        endDate: moment().local().endOf('month').toDate().toISOString(),
        includeDetails: true
      }
      this.$apiService.analyticsService.getRecutValueSummary(filterData)
      .then(response => {
        this.summaryData = response.data
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
    },
    
  }
}
</script>